<template>
    <v-flex xs12>
        <div class="elevation-1">
            <div class="table__overflow">
                <table class="datatable table">
                    <thead>
                    <tr>
                        <th class="column text-xs-left" v-for="header in headers">{{ header }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td v-for="n in item.length">{{ item[n - 1] }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </v-flex>
</template>

<script>
  export default {
    name: 'step-three',
    data () {
      return {
      }
    },
    props: ['headers', 'items'],
    mounted () {
    },
    methods: {}
  }
</script>